module.exports = __webpack_public_path__ + "static/media/kiernan-steel.677ce712.jpg";